module.exports = __webpack_public_path__ + "img/56.62306cb7.jpg";